var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavListWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 14.25V12.75H15.75V14.25H6.75ZM6.75 9.75V8.25H15.75V9.75H6.75ZM6.75 5.25V3.75H15.75V5.25H6.75ZM3.75 15C3.3375 15 2.98438 14.8531 2.69063 14.5594C2.39687 14.2656 2.25 13.9125 2.25 13.5C2.25 13.0875 2.39687 12.7344 2.69063 12.4406C2.98438 12.1469 3.3375 12 3.75 12C4.1625 12 4.51562 12.1469 4.80938 12.4406C5.10313 12.7344 5.25 13.0875 5.25 13.5C5.25 13.9125 5.10313 14.2656 4.80938 14.5594C4.51562 14.8531 4.1625 15 3.75 15ZM3.75 10.5C3.3375 10.5 2.98438 10.3531 2.69063 10.0594C2.39687 9.76563 2.25 9.4125 2.25 9C2.25 8.5875 2.39687 8.23438 2.69063 7.94063C2.98438 7.64688 3.3375 7.5 3.75 7.5C4.1625 7.5 4.51562 7.64688 4.80938 7.94063C5.10313 8.23438 5.25 8.5875 5.25 9C5.25 9.4125 5.10313 9.76563 4.80938 10.0594C4.51562 10.3531 4.1625 10.5 3.75 10.5ZM3.75 6C3.3375 6 2.98438 5.85313 2.69063 5.55938C2.39687 5.26562 2.25 4.9125 2.25 4.5C2.25 4.0875 2.39687 3.73438 2.69063 3.44063C2.98438 3.14687 3.3375 3 3.75 3C4.1625 3 4.51562 3.14687 4.80938 3.44063C5.10313 3.73438 5.25 4.0875 5.25 4.5C5.25 4.9125 5.10313 5.26562 4.80938 5.55938C4.51562 5.85313 4.1625 6 3.75 6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavListWhite);
export default __webpack_public_path__ + "static/media/nav-list-white.d9398c691fbccc1a482be15bd99947a5.svg";
export { ForwardRef as ReactComponent };